.band {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: var(--gap);
  min-width: 0;
}

.charts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: var(--gap);
}

.charts > * {
  min-width: 0;
}

/* The coverage heat map takes the whole row when the band would give it half of a laptop (G-Wadmin-20). A site
   name, a stream and twelve months need about 560px; at 1024 half the band is 430, so the months were cut at
   the card's edge and the red "Missing" ones, which are the point of the picture, fell outside it. */
@media (max-width: 1180px) {
  .charts > [data-testid="band-coverage"] {
    grid-column: 1 / -1;
  }
}
